export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'max'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Box Footprint',
        category: ['User', 'Collection'],
        description: 'Storage box volume (width × length × depth, mm³).',
        unit: 'mm³'
    },
    rules: {
        linked: [],
        legacy: ['version.size.footprint']
    }
}
